export const APP_URL_API = process.env.REACT_APP_APIURL;


// WEBPACK FOOTER //
// ./src/setup/configs.js